import React from "react";
import { useHistory } from "@core/routing/useHistory";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { Person } from "@domain/user/user";
import { fullName } from "@domain/user/utils";
import { Tooltipable } from "@ui/tooltips/tooltipable";
import { row } from "@ui/components/layout";
import { ImageSize, imageSizes, ProfilePicture } from "@ui/components/profile/profilePicture";

interface LiveMembersProps extends React.HTMLAttributes<HTMLDivElement> {
	sample: Person[];
	count: number;
	spacing?: number;
	imageSize?: ImageSize;
	linkDisabled?: boolean;
}
export const LiveMembers: React.FC<LiveMembersProps> = ({
	sample,
	count,
	spacing = -13,
	imageSize,
	linkDisabled,
	...htmlProps
}) => {
	const history = useHistory();

	return (
		<Container {...htmlProps}>
			{sample.map((member, index) =>
				member && member.id ? (
					<Tooltipable key={member.id} text={fullName(member)} offset={-5} dark>
						<MemberPicture
							first={index === 0}
							spacing={spacing}
							picture={member.avatar}
							size={imageSize}
							onClick={() => (!linkDisabled ? history.push(Path.Profile(member)) : undefined)}
						/>
					</Tooltipable>
				) : (
					<></>
				)
			)}
			{count > sample.length ? (
				<OtherMembersCount spacing={spacing} size={imageSize}>
					+{count - sample.length}
				</OtherMembersCount>
			) : null}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: row;
	margin-left: 5px;
	margin-top: 10px;
`;

const MemberPicture = styled(ProfilePicture)<{ first?: boolean; spacing: number }>`
	cursor: pointer;
	margin-left: ${({ first, spacing }) => (first ? 0 : spacing)}px;
	background-color: ${(props) => props.theme.colors.backgroundPrimary};
`;

const OtherMembersCount = styled.div.withConfig({
	shouldForwardProp: (prop) => !["spacing", "size"].includes(prop),
})<{ spacing: number; size?: ImageSize }>`
	${({ theme }) => theme.textStyles.text}
	${row(0, "center", "center")};
	min-width: ${({ size = "default" }) => imageSizes[size]}px;
	height: ${({ size = "default" }) => imageSizes[size]}px;
	margin-left: ${({ spacing }) => spacing}px;
	border: solid 1px;
	border-radius: ${({ size = "default" }) => imageSizes[size] / 2}px;
	border-color: ${({ theme }) => theme.colors.white};
	color: ${({ theme }) => theme.colors.white};
	background-color: ${({ theme }) => theme.colors.textPrimary};
	padding: 6px;
`;
